<template>
  <div class="new-task">
    <!-- <el-card class="task-header" shadow="never">
      <div slot="header" class="card-header">
        <span class="header-title">{{ newTaskItem.description }}</span>
      </div>
      <el-descriptions :column="2" border>
        <el-descriptions-item label="工单提出人">
          {{ newTaskItem.applyName }}
        </el-descriptions-item>
        <el-descriptions-item label="创建时间">
          {{ formatTimestamp(newTaskItem.createTime) }}
        </el-descriptions-item>
        <el-descriptions-item label="项目名称" :span="2">
          <i class="el-icon-office-building" style="margin-right: 5px"></i>
          {{ newTaskItem.projectName }}
        </el-descriptions-item>
      </el-descriptions>
      <div class="image-section" v-if="fileList.length > 0">
        <div class="section-label">附件图片：</div>
        <div class="image-grid">
          <div
            v-for="(image, index) in fileList"
            :key="index"
            class="image-wrapper"
          >
            <el-image
              :src="image"
              class="uploaded-image"
              fit="cover"
              :preview-src-list="fileList"
              :initial-index="index"
            ></el-image>
          </div>
        </div>
      </div>
    </el-card> -->

    <!-- 路线选择区域 -->
    <el-card
      class="road-selection-area"
      shadow="never"
      v-if="busProjectRoads && busProjectRoads.length > 0"
    >
      <div slot="header" class="card-header">
        <span class="header-title">选择路线</span>
      </div>
      <el-radio-group
        v-model="selectedRoadId"
        @change="onSelect"
        class="road-list"
      >
        <el-radio
          v-for="road in busProjectRoads"
          :key="road.id"
          :label="road.id"
          border
        >
          <i class="el-icon-location"></i>
          <span>{{ road.roadName }}</span>
        </el-radio>
      </el-radio-group>
    </el-card>

    <!-- 班组选择区域 -->
    <el-card class="team-selection-area" shadow="never">
      <div slot="header" class="card-header">
        <span class="header-title">选择班组</span>
      </div>
      <el-radio-group
        v-model="selectedOtherTeam"
        @change="handleOtherTeamChange"
        style="width: 100%"
      >
        <el-table
          :data="queryOtherProjectList"
          border
          style="width: 100%"
          height="400"
          ref="otherTeamTable"
          highlight-current-row
          @current-change="handleOtherTeamSelection"
        >
          <el-table-column width="55">
            <template slot-scope="scope">
              <el-radio :label="scope.row.groupId" v-model="selectedOtherTeam"
                >&nbsp;</el-radio
              >
            </template>
          </el-table-column>
          <el-table-column label="班组名称" prop="groupName" min-width="200">
            <template slot-scope="scope">
              <div class="team-name-cell">
                <i class="el-icon-user-solid"></i>
                <span>{{ scope.row.groupName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="车辆信息" prop="carNum" min-width="150">
            <template slot-scope="scope">
              <div v-if="scope.row.carNum" class="car-info">
                <i class="el-icon-truck"></i>
                <span>{{ scope.row.carNum }}</span>
              </div>
              <span v-else class="text-muted">无车辆信息</span>
            </template>
          </el-table-column>
        </el-table>
      </el-radio-group>
    </el-card>

    <div class="task-footer">
      <el-button
        type="primary"
        size="medium"
        :disabled="!selectedRoadId || teamList.length == 0"
        @click="releaseTaskHandle"
        icon="el-icon-s-promotion"
      >
        发布任务
      </el-button>
    </div>

    <el-dialog
      :visible.sync="popupShow"
      width="30%"
      center
      :modal="false"
      custom-class="custom-popup"
    >
      <div
        class="custom-popup-content u-flex u-flex-items-center u-flex-center"
      >
        <!-- <img src="../../../static/images/order/icon-tip.png" alt=""> -->
        <div class="popup-content-text">确定发布任务？</div>
      </div>
      <div
        slot="footer"
        class="custom-popup-footer u-flex u-flex-items-center u-flex-center"
      >
        <el-button class="popup-footer-cancel" @click="popupShow = false"
          >取消</el-button
        >
        <el-button
          class="popup-footer-confirm"
          type="primary"
          @click="confirmReleaseHandle"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import managerApi from "@/api/manager/index.js";

export default {
  name: "NewTaskElement",
  props: {
    selectedRowId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      fileList: [],
      teamList: [],
      popupShow: false,
      newTaskItem: {
        createTime: "",
      },
      teamObj: null,
      actions: [],
      selectedRoadItem: {},
      selectedRoadId: null,
      queryParams: {
        description: "",
        pageDto: {
          current: 1,
          size: 10,
        },
        status: "",
      },
      busProjectRoads: [], // 项目路线信息
      queryOwnProjectList: [], // 本项目班组列表
      queryOtherProjectList: [], // 其他项目班组列表
      workActions: [], // 任务类型列表
      activeTeamTab: "own", // 当前激活的班组标签页
      selectedOwnTeams: [], // 已选中的本项目班组
      selectedOtherTeam: null, // 已选中的其他项目班组
    };
  },

  async created() {
    await managerApi.queryManagerOrderInfo(this.queryParams).then((res) => {
      let allItems = res.data.data.records;

      //循环allItems，将其中的id和route.param.id匹配筛选出需要的数据
      for (let i = 0; i < allItems.length; i++) {
        if (allItems[i].id == this.selectedRowId) {
          this.newTaskItem = allItems[i];
          console.log("newTaskItem", this.newTaskItem);
          break;
        }
      }
      if (
        this.newTaskItem.busProjectRoads &&
        this.newTaskItem.busProjectRoads.length > 0
      ) {
        this.busProjectRoads = this.newTaskItem.busProjectRoads;
      }
      if (this.newTaskItem.photoUrl != "") {
        this.fileList = this.newTaskItem.photoUrl.split(",");
      }
    });

    // 获取班组信息
    await this.queryProjectGroup();

    // 获取任务类型
    await this.queryBusWorkInfo();
  },

  methods: {
    releaseTaskHandle() {
      if (!this.teamList || this.teamList.length == 0) {
        return;
      }
      this.popupShow = true;
    },

    onSelect(roadId) {
      // 在ElementUI中使用radio-group的change事件
      this.selectedRoadItem = this.busProjectRoads.find(
        (road) => road.id === roadId
      );
    },

    confirmReleaseHandle() {
      this.popupShow = false;
      this.addOrderTask();
    },

    async addOrderTask() {
      let orderTaskDtos = [];
      this.teamList.forEach((element) => {
        let flowCarIds = [];
        if (element.carList) {
          for (let i = 0; i < element.carList.length; i++) {
            flowCarIds.push(element.carList[i].id);
          }
        }
        orderTaskDtos.push({
          carId: element.assignMark != 0 ? element.carId : "",
          flowCarIds,
          groupId: element.groupId,
          workId: element.actions[0].id,
        });
      });
      let params = {
        orderId: this.newTaskItem.id,
        roadId: this.selectedRoadItem.roadId,
        roadName: this.selectedRoadItem.roadName,
        orderTaskDtos,
      };
      console.log("params", params);
      try {
        const res = await managerApi.addOrderTask(params);
        if (res.data.code == 200) {
          this.$message({
            message: "发布成功",
            type: "success",
          });
          this.$emit("success");
        } else {
          this.$message.error(res.data.message || "发布失败");
        }
      } catch (error) {
        console.error("发布任务失败:", error);
        this.$message.error("发布失败，请重试");
      }
    },

    deleteTeamHandle(idx) {
      this.teamList.splice(idx, 1);
      localStorage.setItem("teamList", JSON.stringify(this.teamList));
    },

    formatTimestamp(timestamp) {
      if (!timestamp) {
        return "-";
      }
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

      return formattedDate;
    },

    // 弹窗关闭
    popupOnClose() {
      this.popupShow = false;
    },

    // 处理班组选择变化
    handleTeamSelection(index, type) {
      const teamList =
        type === "own" ? this.queryOwnProjectList : this.queryOtherProjectList;
      const team = teamList[index];

      console.log("选择的班组:", team);
      console.log("当前班组列表:", this.teamList);

      if (team.isSelected) {
        // 检查是否已经在teamList中
        const existingIndex = this.teamList.findIndex(
          (t) => t.groupId === team.groupId
        );
        if (existingIndex === -1) {
          // 添加到teamList
          this.teamList.push(team);
        }
      } else {
        // 从teamList中移除
        this.teamList = this.teamList.filter((t) => t.groupId !== team.groupId);
      }

      console.log("更新后的班组列表:", this.teamList);
    },

    // 处理本项目班组表格选择变化
    handleOwnTeamSelection(selection) {
      console.log("本项目班组选择变化:", selection);

      // 更新所有班组的选中状态
      this.queryOwnProjectList.forEach((team) => {
        team.isSelected = selection.some((s) => s.groupId === team.groupId);
      });

      // 更新teamList
      this.updateTeamList();
    },

    // 处理其他项目班组表格选择变化
    handleOtherTeamSelection(currentRow) {
      console.log("其他项目班组选择变化:", currentRow);

      if (currentRow) {
        // 设置选中的班组ID
        this.selectedOtherTeam = currentRow.groupId;

        // 更新所有班组的选中状态
        this.queryOtherProjectList.forEach((team) => {
          team.isSelected = team.groupId === currentRow.groupId;
        });

        // 更新teamList
        this.updateTeamList();
      }
    },

    // 更新teamList
    updateTeamList() {
      // 清空teamList
      this.teamList = [];

      // 添加所有选中的班组
      [...this.queryOwnProjectList, ...this.queryOtherProjectList].forEach(
        (team) => {
          if (team.isSelected) {
            // 确保actions属性存在且不为空
            if (!team.actions || team.actions.length === 0) {
              team.actions =
                this.workActions.length > 0 ? [this.workActions[0]] : [];
            }
            this.teamList.push(team);
          }
        }
      );

      console.log("更新后的teamList:", this.teamList);
    },

    // 处理本项目班组选择变化（checkbox-group）
    handleOwnTeamChange(value) {
      console.log("本项目班组checkbox变化:", value);
    },

    // 处理其他项目班组选择变化（radio-group）
    handleOtherTeamChange(value) {
      console.log("其他项目班组radio变化:", value);
      // 更新teamList
      this.updateTeamList();
    },

    // 获取班组信息
    async queryProjectGroup() {
      const res = await managerApi.queryProjectGroup({
        id: this.newTaskItem.id,
        groupName: "",
      });
      console.log(res, "queryProjectGroup");

      if (res.data.code == 200) {
        this.queryOwnProjectList = res.data.data.ownGroupInfo;
        this.queryOtherProjectList = res.data.data.otherGroupInfo;

        // 初始化班组数据
        this.queryOwnProjectList.forEach((element) => {
          element.actions = [];
          element.isSelected = false;
          element.selectedActionId = null;
        });

        this.queryOtherProjectList.forEach((element) => {
          element.actions = [];
          element.isSelected = false;
          element.selectedActionId = null;
        });
      }
    },

    // 获取任务类型
    async queryBusWorkInfo() {
      const res = await managerApi.queryBusWorkInfo();
      console.log(res, "queryBusWorkInfo");

      if (res.data.code == 200) {
        if (res.data.data && res.data.data.length > 0) {
          this.workActions = res.data.data.map((item) => {
            return {
              id: item.id,
              name: item.workName,
            };
          });
        }
      }
    },

    // 选择班组
    selectTeam(index, type) {
      // 点击事件由checkbox处理，这里可以留空或添加其他逻辑
    },

    // 处理任务类型变化
    handleActionChange(index, type) {
      const teamList =
        type === "own" ? this.queryOwnProjectList : this.queryOtherProjectList;
      const selectedAction = this.workActions.find(
        (action) => action.id === teamList[index].selectedActionId
      );

      if (selectedAction) {
        teamList[index].actions = [
          {
            name: selectedAction.name,
            id: selectedAction.id,
          },
        ];
      }
    },

    // 确认班组选择 - 已移除
    confirmTeamSelection() {
      let tempList = [];

      // 获取已选中的本项目班组
      this.queryOwnProjectList.forEach((element) => {
        if (element.isSelected) {
          tempList.push(element);
        }
      });

      // 获取已选中的其他项目班组
      this.queryOtherProjectList.forEach((element) => {
        if (element.isSelected) {
          tempList.push(element);
        }
      });

      // 将选中的班组添加到teamList
      this.teamList = [...this.teamList, ...tempList];

      // 关闭弹窗
      this.teamDialogShow = false;
    },
  },
};
</script>

<style lang="less" scoped>
.new-task {
  min-height: 50vh;
  background-color: #f5f7fa;

  .task-header {
    .card-header {
      .header-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }
    }

    .image-section {
      margin-top: 20px;

      .section-label {
        font-size: 14px;
        font-weight: 500;
        color: #606266;
        margin-bottom: 12px;
      }

      .image-grid {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;

        .image-wrapper {
          width: 120px;
          height: 120px;
          border-radius: 4px;
          overflow: hidden;
          cursor: pointer;
          border: 1px solid #dcdfe6;
          transition: all 0.3s;

          &:hover {
            border-color: #409eff;
            box-shadow: 0 2px 12px 0 rgba(64, 158, 255, 0.2);
          }

          .uploaded-image {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }

  .task-content {
    .card-header {
      .header-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }
    }

    .team-info {
      display: flex;
      align-items: center;
      gap: 8px;

      i {
        color: #909399;
      }

      span {
        font-size: 14px;
        color: #606266;
      }
    }

    .car-info {
      display: flex;
      align-items: center;
      gap: 8px;

      i {
        color: #909399;
      }

      span {
        font-size: 14px;
        color: #606266;
      }
    }

    .extra-car {
      margin-top: 8px;
    }
  }

  .road-selection-area {
    .card-header {
      .header-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }
    }

    .road-list {
      display: flex;
      gap: 12px;

      ::v-deep .el-radio {
        margin-right: 0;
        margin-bottom: 0;
        width: 100%;

        .el-radio__label {
          align-items: center;
          gap: 8px;
          padding-left: 10px;
        }

        i {
          color: #909399;
        }
      }

      ::v-deep .el-radio.is-bordered {
        padding: 12px 20px;
        border-radius: 4px;
        transition: all 0.3s;

        &:hover {
          border-color: #409eff;
          background-color: #f5f7fa;
        }

        &.is-checked {
          border-color: #409eff;
          background-color: #ecf5ff;
        }
      }
    }
  }

  .team-selection-area {
    .card-header {
      .header-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }
    }

    .team-name-cell {
      display: flex;
      align-items: center;
      gap: 8px;

      i {
        color: #909399;
      }

      span {
        font-size: 14px;
        color: #606266;
      }
    }

    .car-info {
      display: flex;
      align-items: center;
      gap: 8px;

      i {
        color: #909399;
      }

      span {
        font-size: 14px;
        color: #606266;
      }
    }

    .text-muted {
      color: #909399;
      font-size: 14px;
    }

    ::v-deep .el-tabs {
      .el-tabs__header {
        margin-bottom: 0;
      }

      .el-tabs__content {
        padding: 20px;
      }
    }
  }

  .task-footer {
    display: flex;
    justify-content: center;
    padding: 20px 0;
    background-color: #fff;
    border-radius: 4px;
  }
}

.image-preview-dialog {
  ::v-deep .el-dialog__body {
    padding: 0;
  }
}

.preview-image {
  width: 100%;
  height: 100%;
}

.custom-popup {
  ::v-deep .el-dialog__body {
    padding: 20px;
  }

  .custom-popup-content {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 0;

    .popup-content-text {
      font-size: 16px;
      font-weight: 500;
      color: #303133;
    }
  }

  .custom-popup-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    margin-top: 20px;
  }
}
</style>
